import { useEffect, useLayoutEffect } from "react";
import { pageview } from './analytics';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"; 
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Resume from "./pages/Resume";
// import Timeline from "./pages/Timeline";
// import Qualifications from "./pages/Qualifications";
import Skills from "./pages/Skills";
import Articles from "./pages/Articles";
import TechLogosScroll from "./components/TechLogosScroll";
import Footer from './components/Footer';
import ThemeToggle from "./components/ThemeToggle";
import UnderConstruction from './pages/UnderConstruction';
import PEM from './pages/client_projects/Pem';
import MRR from './pages/client_projects/Mrr';
import CustomerBehavior from './pages/client_projects/CustomerBehavior';
import EffortEstimation from './pages/client_projects/EffortEstimation';
import AiChatbot from './pages/client_projects/AiChatbot';
import ErdCompiler from './pages/client_projects/ErdCompiler';
import Aegis from './pages/client_projects/Aegis';


function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}


function AppRoutes() {
  const location = useLocation();

  useLayoutEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);
  
  // List of routes where Navbar should NOT be shown
  const hideNavbarRoutes = ['/under-construction', '/faq', '/pem', '/mrr', '/customer-behavior-analysis',
    '/effort-estimation', '/ai-chatbot', '/erd-script-compiler', '/aegis-aidp',
  ];

  // Dynamically change the title based on the route
  useEffect(() => {

    const titleMap = {
      "/under-construction": "Under Construction",
      "/faq": "FAQ",
      "/pem": "PEM",
      "/mrr": "MRR",
      "/customer-behavior-analysis": 'Customer Behavior',
      "/effort-estimation": "Effort Estimation",
      "/ai-chatbot": "AI Chatbot",
      "/erd-script-compiler": "ERD Script Compiler (Pilot)",
      "/aegis-aidp": "Agentic Data Intelligence Platform"
    };

    document.title = titleMap[location.pathname] || "Tuhin Kumar Dutta | Data & AI/ML Engineer Portfolio"
  
    document.documentElement.style.scrollBehavior = "auto";
  
    const timeout = setTimeout(() => {
      document.documentElement.style.scrollBehavior = "smooth";
    }, 500);
  
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  // Track page views for analytics
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <ThemeToggle />
      {/* Conditionally render Navbar based on the current route */}
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}

      <div className={hideNavbarRoutes.includes(location.pathname) ? "detail-page-shell" : "portfolio-main"}>
        <Routes> {/* ✅ all routes go inside this */}
          <Route path="/" element={
            <>
              <Home id="home" />
              <About id="about" />
              <Resume id="resume" />
              {/* <Timeline id="timeline" /> */}
              <Skills id="skills" />
              <TechLogosScroll />
              {/* <Qualifications id="qualifications" /> */}
              <Articles id="articles" />
              <Projects id="projects" />
              <Footer />
            </>
          } />
          
          <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/pem" element={<PEM />} />
          <Route path="/mrr" element={<MRR />} />
          <Route path="/customer-behavior-analysis" element={<CustomerBehavior />} />
          <Route path="/effort-estimation" element={<EffortEstimation />} />
          <Route path="/ai-chatbot" element={<AiChatbot />} />
          <Route path="/erd-script-compiler" element={<ErdCompiler />} />
          <Route path="/aegis-aidp" element={<Aegis />} />
        </Routes>
      </div>
    </>
  );
}

export default App;